export enum HelpAudience {
  PUBLIC = "PUBLIC",
  STORE = "STORE",
  RESELLER = "RESELLER",
  BRAND = "BRAND",
  ADMIN = "ADMIN",
}
